export default __webpack_public_path__ + "static/media/item-5.f87f6cf5.png";